<template>
  <div>
    <div class="theRecords">
      <div class="basic-information-title">问卷记录</div>
      <div>
        <img
          :src="require('@/assets/img/newlyAdd.png')"
          class="newlyAddImg"
          alt
          @click="newSurvey()"
          srcset
          v-if="hasSurveyCreated"
        />
      </div>
    </div>
    <van-popup
      v-model="showSelectSurvey"
      :close-on-click-overlay="true"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="availabeleSurvey"
        value-key="name"
        @cancel="onCancelSurverySelection"
        @confirm="onConfirmSurverySelection"
      />
    </van-popup>
    <div class="product-list" v-if="list.length > 0">
      <div v-for="(item, index) in list" v-bind:key="index">
        <div class="product-list-content" @click="viewSurvey(item)">
          <!--v-bind:class="item.edit==true?'activeno':'active'"  -->
          <div class="basic-information-flex">
            <ul class="basic-information-lists">
              <li>
                <div class="basic-information-lists-item">问卷类型</div>
                <div class="basic-information-lists-text">
                  {{ item.survey_type | formatType }}
                </div>
              </li>
              <li>
                <div class="basic-information-lists-item">问卷名称</div>
                <div class="basic-information-lists-text">{{ item.name }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">提交时间</div>
                <div class="basic-information-lists-text">
                  {{ item.create_time }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { format } from "date-fns";

export default {
  name: "",
  props: {
    // 在该视图上的高度
    custId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
      availabeleSurvey: [],
      showSelectSurvey: false,
      hasSurveyCreated: false, // 问卷创建权限
    };
  },
  filters: {
    formatType: function (value) {
      if (value === 1) {
        return "微信问卷";
      }
      if (value === 2) {
        return "产品问卷";
      }
      if (value === 3) {
        return "企业微信问卷";
      }
      return value;
    },
  },
  methods: {
    /**
     *
     *  问卷列表查询
     *
     */
    getCustListSurvey(custId) {
      this.$api
        .getCustListSurvey({
          salesId: this.$wxuserUtil.getUserId(),
          custId: custId,
          pageSize: 9999,
        })
        .then((Response) => {
          if (Response.success == true) {
            this.list = Response.data;
          } else {
            this.$title(Response.msg);
          }
        });
    },
    async newSurvey() {
      await this.queryAvailableSurvey();
      if (this.availabeleSurvey.length === 0) {
        this.$title("暂无可用调研问卷可以创建");
        return;
      }
      if (this.availabeleSurvey.length === 1) {
        this.redirectSubmitSurvey(this.availabeleSurvey[0].survey_sfdc_id);
        return;
      }
      console.log(this.availabeleSurvey);
      this.showSelectSurvey = true;
    },
    async queryAvailableSurvey() {
      try {
        let response = await this.$api.querySurveyByPurchaseRecord({
          custId: this.custId,
          salesId: this.$wxuserUtil.getUserId(),
        });
        if (response.fail) {
          this.$title("查询可用调研问卷列表失败");
          return;
        }
        this.availabeleSurvey = response.data
          ? response.data.availableSurveys || []
          : [];
      } catch (error) {
        console.log(error);
        this.$title("查询可用调研问卷列表失败");
      }
    },
    onCancelSurverySelection() {
      this.showSelectSurvey = false;
    },
    onConfirmSurverySelection(value) {
      console.log("value", value);
      let surveyId = value.survey_sfdc_id;
      this.showSelectSurvey = false;
      this.redirectSubmitSurvey(surveyId);
    },
    redirectSubmitSurvey(surveyId) {
      console.log("surveyId", surveyId);
      this.$router.push({
        path: "/submit-survey",
        query: {
          surveyId: surveyId,
          custId: this.custId,
        },
      });
    },
    viewSurvey(item) {
      if (!item.survey_sfdc_id) {
        return;
      }
      this.$router.push({
        path: "/view-survey",
        query: {
          surveyId: item.survey_sfdc_id,
          groupCode: item.groupCode,
          custId: this.custId,
        },
      });
    },
  },
  mounted() {
    // 检查问卷创建权限
    this.hasSurveyCreated = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.SurveyCreated);
  },
  created() {},
};
</script>



<style lang="less" scoped>
.theRecords {
  // width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  padding: 0.3rem 0.5rem 0rem 0.5rem;
  border-top: 0.1rem solid rgb(244, 244, 244);
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
  .basic-information-title {
    position: relative;
    color: #2a2a2a;
    font-size: 0.4rem;
    font-weight: 600;
  }
  .basic-information-title::after {
    content: "";
    width: 0.1rem;
    height: 0.35rem;
    position: absolute;
    left: -0.2rem;
    top: 0.12rem;
    background-color: #e10913;
  }
}

.product-list {
  margin: 0.3rem 0.5rem 0.3rem 0.5rem;
  // background: #F2F2F2;
  min-height: 1rem;
  .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    .basic-information-lists {
      li {
        display: flex;
        //    justify-content: space-between;
        -ms-flex-item-align: center;
        align-items: center;
        height: 0.8rem;
        line-height: 0.8rem;
      }
      .basic-information-lists-item {
        width: 2.5rem;
        color: #7e7e7e;
        font-size: 0.35rem;
      }
      .basic-information-lists-text {
        font-size: 0.35rem;
        color: #4d4d4d;
      }
    }
  }
  .product-list-content {
    background: #f2f2f2;
    margin-bottom: 0.3rem;
  }
  .packUp {
    padding: 0rem 0.3rem;
    background: #f2f2f2;
    margin-top: 0.05rem;
    margin-bottom: 0.3rem;
    height: 1rem;
    line-height: 1rem;
  }
  .arrow {
    width: 0.4rem;
    height: 0.4rem;
  }
  .product-list-header {
    height: 1rem;
    -ms-flex-item-align: center;
    align-items: center;
    padding: 0rem 0.3rem;
    flex-direction: row;
    justify-content: space-between;
    background: #f2f2f2;
    .product-name {
      color: #2a2a2a;
      font-size: 0.4rem;
      padding-left: 0.3rem;
    }
  }
  .camera,
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
}
.newlyAddImg {
  width: 0.5rem;
  height: 0.5rem;
}
</style>




// WEBPACK FOOTER //
// src/components/client/childCompoents/theRecords.vue